import { PrivacyPolicyLink } from "./PrivacyPolicyLink";
import { church } from "src/core/church/church";

export const CopyrightFooter = () => (
    <>
        <p className="text-center text-gray-400 text-xs">
            Copyright © 2022—{new Date().getFullYear()}&nbsp;&bull;&nbsp;
            {church.websiteUrl ? (
                <a href={church.websiteUrl} target="_blank" rel="noreferrer">
                    {church.name}
                </a>
            ) : (
                church.name
            )}
        </p>

        <p className="text-center text-gray-400 text-xs">
            <PrivacyPolicyLink />
            &nbsp;&bull;&nbsp;
            {import.meta.env.VITE_RELEASE_VERSION || "dev"}
        </p>
    </>
);
